export interface ICategory {
  identifier: string;
  sortOrder: number;
  name: string;
  name_en: string;
  name_cn: string;
  name_kr: string;
  superItemCategory: string;
  limited: number;
}
export class CategoryDTO implements ICategory {
  identifier: string;
  sortOrder: number;
  name: string;
  name_en: string;
  name_cn: string;
  name_kr: string;
  superItemCategory: string;
  limited: number;
}

export default class Category extends CategoryDTO {
  constructor(dto?: CategoryDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      sortOrder: 0,
      name: "",
      name_en: "",
      name_cn: "",
      name_kr: "",
      superItemCategory: "",
      limited: 0,
    });
  }
}
